const moduleName = "komplainQrisModule";

const state = {
    listKomplain: [],
    detailKomplain: {},
    listAkunRefund: [],
    scrollState: 0,
    needReload: false,
    listTransaksi: [],
    listTransaksiSearch: [],
    listTransaksiSnap: [],
    countData: 0,
};

export { state as default, moduleName };
